import { Normalize } from "@/api/normalize/normalize";
import { maskBirthDate, maskCep, maskCpf, maskPhone } from "@/components/wizard/masks";
import { djs } from "@/lib/djs";
import { CadastroLabels } from "@/lib/labels";

export const CadastroFields = {
	displayPhone(stored: string) {
		const phone = Normalize.phone(stored);

		if (phone === null || phone.norm === null || phone.kind === "international") {
			return stored;
		}

		return maskPhone(phone.norm);
	},

	displayBirthDate(stored: string) {
		if (stored === "") {
			return "";
		}

		return djs(stored, "YYYY-MM-DD").format("DD/MM/YYYY");
	},

	cpfError(value: string) {
		if (value.trim() === "") {
			return null;
		}

		const parsed = Normalize.cpf(value);

		if (!parsed || !parsed.valid) {
			return "CPF invalido";
		}

		return null;
	},

	birthDateError(value: string) {
		if (value.trim() === "") {
			return null;
		}

		const parsed = djs(value, "DD/MM/YYYY", true);

		if (!parsed.isValid()) {
			return "Data invalida";
		}

		return null;
	},
};

export interface CadastroTextField {
	label: string;
	mask?: (value: string) => string;
	placeholder?: string;
	validate?: (value: string) => string | null;
}

const FIELD = CadastroLabels.field;

export const CADASTRO_TEXT_FIELDS = {
	name: { label: FIELD.name },
	cpf: {
		label: FIELD.cpf,
		mask: maskCpf,
		placeholder: "000.000.000-00",
		validate: CadastroFields.cpfError,
	},
	rg: { label: FIELD.rg },
	sex: { label: FIELD.sex },
	birth_date: {
		label: FIELD.birth_date,
		mask: maskBirthDate,
		placeholder: "DD/MM/AAAA",
		validate: CadastroFields.birthDateError,
	},
	mother_name: { label: FIELD.mother_name },
	marital_status: { label: FIELD.marital_status },
	occupation: { label: FIELD.occupation },
	insurance: { label: FIELD.insurance },
	preferred_channel: { label: FIELD.preferred_channel },
	how_found: { label: FIELD.how_found },
	how_found_detail: { label: FIELD.how_found_detail },
	referred_by: { label: FIELD.referred_by },
	address_raw: { label: FIELD.address, placeholder: "Rua, numero, bairro, cidade" },
	address_cep: { label: FIELD.cep, mask: maskCep, placeholder: "00000-000" },
} satisfies Record<string, CadastroTextField>;

export type CadastroTextKey = keyof typeof CADASTRO_TEXT_FIELDS;
